<!--<app-header-top #headerTop [title]="'Cliente'" [links]="links"></app-header-top>-->

<div class="container">
   <div *ngIf="!isVendita">
   <h2 *ngIf="isNew" class="mt-5">Nuovo Cliente</h2>
   <h2 *ngIf="!isNew" class="mt-5">Cliente {{cliente.data.id}} - {{cliente.data.nome}} {{cliente.data.cognome}}</h2>
   </div>
<!--   <mat-tab-group mat-align-tabs="left" class="invisible-tabs" #tabs [selectedIndex]="selectedIndex">-->
<!--      <mat-tab label="Dati clienti">-->
         <div class="m-1">
            <form class="mt-3" [formGroup]="clienteFrm">

               <div class="grid grid-cols-12 gap-4">

                  <div class="col-span-12 lg:col-span-6">
                     <mat-label>Nome</mat-label>
                     <mat-form-field class="w-full" appearance="fill">
                        <input matInput type="text" formControlName="nome">
                        <mat-error *ngIf="clienteFrm.get('nome')?.hasError('required')">
                           Il Nome è <strong>obbligatorio</strong>
                        </mat-error>
                     </mat-form-field>
                  </div>

                  <div class="col-span-12 lg:col-span-6">
                     <mat-label>Cognome</mat-label>
                     <mat-form-field class="w-full" appearance="fill">
                        <input matInput type="text" formControlName="cognome">
                        <mat-error *ngIf="clienteFrm.get('cognome')?.hasError('required')">
                           Il Cognome è <strong>obbligatorio</strong>
                        </mat-error>
                     </mat-form-field>
                  </div>

                  <div class="col-span-12 lg:col-span-2">
                     <mat-label>Prefisso</mat-label>
                     <mat-form-field class="w-full" appearance="fill">
                        <input matInput type="text" formControlName="cellulare_prefix">
                     </mat-form-field>
                  </div>

                  <div class="col-span-12 lg:col-span-4">
                     <mat-label>Telefono</mat-label>
                     <mat-form-field class="w-full" appearance="fill">
                        <input matInput type="text" formControlName="telefono">
<!--                        <mat-error *ngIf="clienteFrm.get('cognome')?.hasError('required')">-->
<!--                           Il Cognome è <strong>obbligatorio</strong>-->
<!--                        </mat-error>-->
                     </mat-form-field>
                  </div>

                  <div class="col-span-12 lg:col-span-3">
                     <mat-label>Data di nascita</mat-label>
                     <mat-form-field class="w-full" appearance="fill">
                        <input matInput [matDatepicker]="picker" formControlName="data_nascita">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                     </mat-form-field>
                  </div>

                  <div class="col-span-12 lg:col-span-3">
                     <mat-label>Sesso</mat-label>
                     <mat-form-field class="w-full" appearance="fill">
                        <mat-select formControlName="sesso" placeholder="Sesso">
                           <mat-option *ngFor="let s of Cliente.Sesso"
                                       value="{{s.value}}">
                              {{s.display}}
                           </mat-option>
                        </mat-select>
                     </mat-form-field>
                  </div>

                  <div class="col-span-12 lg:col-span-6">
                     <mat-label>Email</mat-label>
                     <mat-form-field class="w-full" appearance="fill">
                        <input matInput type="email" formControlName="email">
                        <mat-error *ngIf="clienteFrm.get('email')?.hasError('required')">
                           L'email è <strong>obbligatoria</strong>
                        </mat-error>
                     </mat-form-field>
                  </div>

                  <div class="col-span-12 lg:col-span-6">
                     <mat-label>Conferma email</mat-label>
                     <mat-form-field class="w-full" appearance="fill">
                        <input matInput type="email" formControlName="conferma_email">
                        <mat-error *ngIf="clienteFrm.get('conferma_email')?.hasError('required')">
                           L'email è <strong>obbligatoria</strong>
                        </mat-error>
                        <mat-error *ngIf="clienteFrm.hasError('not_same_email')">
                           Le email non corrispondono
                        </mat-error>
                     </mat-form-field>
                  </div>

<!--                  <div class="col-span-12 lg:col-span-12">-->
<!--                     <mat-label>Interessi</mat-label>-->
<!--                     <mat-form-field class="w-full" appearance="fill" >-->
<!--                        <mat-select style="border: none" formControlName="interessi" placeholder="interessi" multiple>-->
<!--                           <mat-option *ngFor="let interesse of interessi" [value]="interesse.data.id">{{interesse.data.nome}}</mat-option>-->
<!--                        </mat-select>-->
<!--                     </mat-form-field>-->
<!--                  </div>-->

                  <div class="col-span-12 lg:col-span-12">
                     <mat-label>Campo Note</mat-label>
                     <mat-form-field *ngIf="is_vendor || isVendita" class="example-full-width w-full" appearance="fill">
                        <textarea matInput placeholder="" formControlName="note_vendor"></textarea>
                     </mat-form-field>
                  </div>

                  <div class="col-span-12 lg:col-span-12">
                     <label id="example-radio-group-label">Privato / Azienda</label>
                  </div>
                  <div class="col-span-12 lg:col-span-12">
                     <mat-radio-group class="example-radio-group" aria-label="Select an option" formControlName="tipo" aria-labelledby="example-radio-group-label">
                        <mat-radio-button class="mx-2" *ngFor="let s of Cliente.Tipo" value="{{s.value}}" (change)="onChangeTipo($event)">{{s.display}}</mat-radio-button>
                     </mat-radio-group>
                  </div>
               </div>

               <div *ngIf="clienteFrm.get('tipo')?.value == 'AZ'" class="mt-5 grid grid-cols-12 gap-4">
                  <h2 class="my-1 col-span-12">Ragione Sociale Azienda</h2>

                  <div class="col-span-12 lg:col-span-12">
                     <mat-label>Nome dell'impresa</mat-label>
                     <mat-form-field class="w-full" appearance="fill">
                        <input matInput type="text" formControlName="ragione_sociale">
                     </mat-form-field>
                  </div>

                  <div class="col-span-12 lg:col-span-3" formGroupName="indirizzo">
                     <mat-label>Stato</mat-label>
                     <mat-form-field class="w-full" appearance="fill">
                        <mat-select #selectStato formControlName="stato" (selectionChange)="this.indirizzoSrv.onChangeStato($event.source.triggerValue)">
                           <mat-option *ngFor="let stato of this.indirizzoSrv.arrStati"
                                       value="{{stato.data.id}}">{{stato.data.nome}}</mat-option>
                        </mat-select>
                     </mat-form-field>
                  </div>

                  <div class="col-span-12 lg:col-span-3" formGroupName="indirizzo">
                     <mat-label>Regione</mat-label>
                     <mat-form-field class="w-full" appearance="fill">
                        <mat-select #selectRegione formControlName="regione" (selectionChange)="indirizzoSrv.regioneChange($event.value)">
                           <mat-option *ngFor="let regione of indirizzoSrv.arrRegioni"
                                       value="{{regione.data.id}}">{{regione.data.nome}}</mat-option>
                        </mat-select>
                     </mat-form-field>
                  </div>

                  <div class="col-span-12 lg:col-span-3" formGroupName="indirizzo">
                     <mat-label>Provincia</mat-label>
                     <mat-form-field class="w-full" appearance="fill">
                        <mat-select #selectProvincia formControlName="provincia" (selectionChange)="indirizzoSrv.provinciaChange($event.value)">
                           <mat-option *ngFor="let provincia of indirizzoSrv.arrProvince"
                                       value="{{provincia.data.id}}">{{provincia.data.nome}}</mat-option>
                        </mat-select>
                     </mat-form-field>
                  </div>

                  <div class="col-span-12 lg:col-span-3" formGroupName="indirizzo">
                     <mat-label>Citta</mat-label>
                     <mat-form-field class="w-full" appearance="fill">
                        <mat-select formControlName="citta">
                           <mat-option *ngFor="let citta of indirizzoSrv.arrCitta"
                                       value="{{citta.data.id}}">{{citta.data.nome}}</mat-option>
                        </mat-select>
                     </mat-form-field>
                  </div>

                  <div class="col-span-12 lg:col-span-8" formGroupName="indirizzo">
                     <mat-label>Indirizzo</mat-label>
                     <mat-form-field class="w-full" appearance="fill">
                        <input matInput type="text" formControlName="indirizzo">
                     </mat-form-field>
                  </div>


                  <div class="col-span-12 lg:col-span-2" formGroupName="indirizzo">
                     <mat-label>Numero civico</mat-label>
                     <mat-form-field class="w-full" appearance="fill">
                        <input matInput type="text" formControlName="civico">
                     </mat-form-field>
                  </div>

                  <div class="col-span-12 lg:col-span-2" formGroupName="indirizzo">
                     <mat-label>CAP</mat-label>
                     <mat-form-field class="w-full" appearance="fill">
                        <input matInput type="text" formControlName="cap">
                     </mat-form-field>
                  </div>

                  <div class="col-span-12 lg:col-span-6">
                     <mat-label>Partita IVA o Codice Fiscale</mat-label>
                     <mat-form-field class="w-full" appearance="fill" >
                        <input matInput type="text" formControlName="pivacf">
                     </mat-form-field>
                  </div>

                  <div class="col-span-12 lg:col-span-6">
                     <mat-label>PEC</mat-label>
                     <mat-form-field class="w-full" appearance="fill">
                        <input matInput type="text" formControlName="pec">
                     </mat-form-field>
                  </div>

                  <div class="col-span-12 lg:col-span-6">
                     <mat-label>Numero REA</mat-label>
                     <mat-form-field class="w-full" appearance="fill">
                        <input matInput type="text" formControlName="n_rea">
                     </mat-form-field>
                  </div>

                  <div class="col-span-12 lg:col-span-6">
                     <mat-label>Codice SDI - Codice destinatarto per le fatture elettroniche</mat-label>
                     <mat-form-field class="w-full" appearance="fill">
                        <input matInput type="text" formControlName="cod_sdi">
                     </mat-form-field>
                  </div>



               </div>
            </form>

            <hr class="my-5">

            <h2 class="mt-5">Listini cliente</h2>

            <app-alert message="Per associare un listino promozionale a un cliente, è necessario prima generare un listino promozionale specifico per il punto vendita."></app-alert>
            <div class="inline-block min-w-full py-2 align-middle">
               <div class="overflow-hidden ring-1 ring-black ring-opacity-5">
                  <table class="min-w-full divide-y divide-gray-300 tbl-header-dark">
                     <thead>
                     <tr>
                        <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold sm:pl-6">Punto vendita</th>
                        <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold">Listini</th>
                        <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold" *ngIf="!isNew">Elimina Listino</th>
                     </tr>
                     </thead>
                     <tbody class="divide-y divide-gray-200 bg-white">
                     <tr *ngFor="let p of listiniGrouped; let i = index">
                        <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">{{p.pvendita_nome}}</td>
                        <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                           <form [formGroup]="listinoSelFrm">
                              <ng-container formArrayName="list_sel">
                                 <mat-form-field class="col-span-6 lg:col-span-1" appearance="fill">
                                    <mat-label>Scegli listino</mat-label>
                                    <mat-select (selectionChange)="setListinoCliente($event, p.pvendita, i) " [formControlName]="i">
                                       <mat-option *ngFor="let listino of p.listini" [value]="listino.id">{{listino.nome}}</mat-option>
                                    </mat-select>
                                 </mat-form-field>
                              </ng-container>
                           </form>
                        </td>
                        <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6" *ngIf="!isNew">
                           <button class="ds-btn ds-btn-info ds-btn-outline ds-btn-sm border-ibm-primary disabled:border-gray-400" [disabled]="!this.listinoSelFrm.value['list_sel'][i]" (click)="clickDissociaListinoCliente(p.pvendita, i)">Dissocia listino</button>
                        </td>

                     </tr>
                     </tbody>
                  </table>
               </div>
            </div>
         </div>

         <div class="pulsantiera my-3 py-3">
<!--            <button *ngIf="!is_vendor" class="ds-btn ds-btn-info" (click)="clickSalvaCliente()">Salva</button>-->
<!--            <button *ngIf="is_vendor && isNew " class="ds-btn ds-btn-info" (click)="clickSalvaVendorCliente()">Salva</button>-->
<!--            <button *ngIf="is_vendor && !isNew" class="ds-btn ds-btn-info" (click)="clickSalvaVendorCliente()">Salva</button>-->
<!---->
<!---->
            <button class="ds-btn ds-btn-info" (click)="is_vendor && isNew ? clickSalvaVendorCliente() : clickSalvaCliente()" *ngIf="!(!is_vendor || isNew) || is_vendor">Salva</button>


         </div>
<!--      </mat-tab>-->
      <!--      <mat-tab label="Assegna listini">-->

      <!--      </mat-tab>-->
<!--   </mat-tab-group>-->
</div>



